const businessType = () => import('@/view/business/business-type');
const businessApply = () => import('@/view/business/business-apply');
const applyDetail = () => import('@/view/business/apply-detail');

export default [{
  path: '/business-type',
  name: 'businessType',
  component: businessType
}, {
  path: '/business-apply',
  name: 'businessApply',
  component: businessApply
}, {
  path: '/apply-detail',
  name: 'applyDetail',
  component: applyDetail
}];
